<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="차량선택"
                [(ngModel)]="dtgCarNo"
                (click)="clickOpenModalGeofenceCarList(DtgActionType.read)"
                readonly>
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickOpenModalGeofenceCarList(DtgActionType.read)">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        차량검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        요일
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="runDay"
                (ngModelChange)="changeRunDay($event)"
                readonly>
                <option [ngValue]="'1'">일요일</option>
                <option [ngValue]="'2'">월요일</option>
                <option [ngValue]="'3'">화요일</option>
                <option [ngValue]="'4'">수요일</option>
                <option [ngValue]="'5'">목요일</option>
                <option [ngValue]="'6'">금요일</option>
                <option [ngValue]="'7'">토요일</option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        회차
                    </span>
                </label>
            </div>
            <input type="number"
                class="form-control form-control-sm"
                style="width: 80px;"
                [(ngModel)]="runCnt"
                min="1"
                (ngModelChange)="changeRunCnt($event)"
                readonly>
            <!-- <select class="form-control form-control-sm"
                [(ngModel)]="runCnt"
                (ngModelChange)="changeRunCnt($event)">
                <option *ngFor="let item of listRunCnt;" [ngValue]="item">{{item}}회차</option>
            </select> -->
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="row">
    <div class="col">
        <div class="table-responsive mt-3">
            <table class="table table-sm table-hover align-items-center mb-0">
                <thead class="">
                    <tr>
                        <th>
                            순서
                        </th>
                        <th>
                            설정이름
                        </th>
                        <th>
                            설정형태
                        </th>
                        <th [hidden]="listType === DtgListType.modal">
                            편집
                        </th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr *ngFor="let item of listGeofence;index as idx;">
                        <td>
                            <span class="">
                                {{item.runOrder}}
                            </span>
                            <span class="ml-3">
                                <span role="button" class="btn-link px-1"
                                    (click)="changeRunOrder(item,'up')"
                                    [hidden]="idx === 0">
                                    <i class="fas fa-chevron-up"></i>
                                </span>
                                <span role="button" class="btn-link px-1"
                                    (click)="changeRunOrder(item,'down')">
                                    <i class="fas fa-chevron-down"></i>
                                </span>
                            </span>
                        </td>
                        <td>
                            <button type="button" class="btn btn-sm btn-link px-0"
                                (click)="clickOpenModalGeofenceInfo(DtgActionType.read,item)">
                                <span>{{item.geoFenceNm}}</span>
                            </button>
                        </td>
                        <td [ngSwitch]="item.shapeType">
                            <span *ngSwitchCase="'C'">원형</span>
                            <span *ngSwitchCase="'R'">사각형</span>
                            <span *ngSwitchDefault>다각형</span>
                        </td>
                        <td [hidden]="listType === DtgListType.modal">
                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                (click)="deleteRunOrder(item)">
                                <i class="mdi mdi-minus"></i>
                                <span class="ml-1">제거</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
    <div class="col-auto">
        <div class="table-responsive mt-3">
            <table class="table table-sm table-hover align-items-center mb-0">
                <thead class="">
                    <tr>
                        <th>
                            설정이름
                        </th>
                        <th>
                            설정형태
                        </th>
                        <th [hidden]="listType === DtgListType.modal">
                            편집
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listGeofenceConf | filterGeoFenceExist:listGeofence;">
                        <td>
                            <button type="button" class="btn btn-sm btn-link px-0"
                                (click)="clickOpenModalGeofenceInfo(DtgActionType.read,item)">
                                <span>{{item.geoFenceNm}}</span>
                            </button>
                        </td>
                        <td [ngSwitch]="item.shapeType">
                            <span *ngSwitchCase="'C'">원형</span>
                            <span *ngSwitchCase="'R'">사각형</span>
                            <span *ngSwitchDefault>다각형</span>
                        </td>
                        <td [hidden]="listType === DtgListType.modal">
                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                [class.disabled]="!dtgUnitId"
                                (click)="addRunOrder(item)">
                                <i class="mdi mdi-plus"></i>
                                <span class="ml-1">추가</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
